import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, ErrorCodes } from '@nosinovacao/nosid-mfe-common';

export function useActivateMfa() {
  return useNosIdMutation({
    mutationFn: (code: string) => api.post('/api/v1/mfa/activate', { Code: code }),
    // ? an invalid code is shown inline on the otp field instead of as a snackbar
    ignoreSnackbarForErrors: [ErrorCodes.SecurityCodeInvalid, ErrorCodes.InvalidSecurityCode],
    successLogAction: () => ({ ActionType: ActionType.Submit, Option: 'AuthenticatorApp' }),
    errorLogAction: () => ({ ActionType: ActionType.Submit, Option: 'AuthenticatorApp' }),
  });
}
